<mat-dialog-content>
  <p>Are you sure you want to remove the recurring payment?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button style="float: right;" mat-button (click)="onOk()">Yes</button>
  <button style="float: right;" mat-button (click)="onCancel()">No</button>
</mat-dialog-actions>